import Vue from 'vue'
import App from './App'
import router from './router'

// Vue.use(VueRouter)
// /* eslint-disable */
// const router = new VueRouter({
//   mode: 'history',
//   base: __dirname,
//   routes: [
//   { path: '/:id', component: App },
//   // { path: '*', redirect: '/' },
// ],
// })

new Vue({
  router,
  el: '#app',
  render: h => h(App),
})
